import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { BibliographyClass, CollectionFlag, Prefix, SearchType } from '@/types'
import { dateToPlainFormat } from '@/utils'

export interface BorrowHistory {
  borrowingId: number
  borrowingDate: string
  borrowingDueDate: string
  interlibraryLoanCode: SystemCode
  requestBranchCode: SystemCode
  returnDate: string
  searchType: SearchType
  bibliographyRealId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  collectionFlag: CollectionFlag
  displayTitle: string
  sortTitle: string
  displayAuthor: string
  sortAuthor: string
  displayPublisher: string
  sortPublisher: string
  collectionType: SystemCode
  collectionNo: string
  borrowingStatus: BorrowingStatus
  appendixCode: SystemCode
  userId: string
  dueDate: string
  revision: number
}

export const BorrowingStatus = {
  Borrowing: '1',
  Returned: '2',
  Lending: '3',
  LendingWait: '4'
} as const
export type BorrowingStatus = typeof BorrowingStatus[keyof typeof BorrowingStatus]

export function BorrowHistoryFromJSON(json: any): BorrowHistory {
  return {
    borrowingId: exists(json, 'borrowing_id') ? json.borrowing_id : 0,
    borrowingDate: exists(json, 'borrowing_date')
      ? dateToPlainFormat(json.borrowing_date)
      : '',
    borrowingDueDate: exists(json, 'borrowing_due_date')
      ? dateToPlainFormat(json.borrowing_due_date)
      : '',
    interlibraryLoanCode: exists(json, 'interlibrary_loan_code')
      ? SystemCodeFromJSON(json.interlibrary_loan_code)
      : defaultSystemCode(),
    requestBranchCode: exists(json, 'request_branch_code')
      ? SystemCodeFromJSON(json.request_branch_code)
      : defaultSystemCode(),
    returnDate: exists(json, 'return_date')
      ? dateToPlainFormat(json.return_date)
      : '',
    searchType: exists(json, 'search_type')
      ? json.search_type
      : SearchType.Book,
    bibliographyRealId: exists(json, 'bibliography_real_id')
      ? json.bibliography_real_id
      : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    sortTitle: exists(json, 'sort_title') ? json.sort_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    sortAuthor: exists(json, 'sort_author') ? json.sort_author : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    sortPublisher: exists(json, 'sort_publisher') ? json.sort_publisher : '',
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    borrowingStatus: exists(json, 'borrowing_status')
      ? json.borrowing_status
      : BorrowingStatus.Borrowing,
    appendixCode: exists(json, 'appendix_code')
      ? SystemCodeFromJSON(json.appendix_code)
      : defaultSystemCode(),
    userId: exists(json, 'user_id') ? json.user_id : '',
    dueDate: exists(json, 'due_date') ? dateToPlainFormat(json.due_date) : '',
    revision: exists(json, 'revision') ? json.revision : ''
  }
}
